import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { ReqMethods, ghl } from "../../enums";
import env from "../../config/env";
import { useAppServices } from "../../hook/services";
import img from "../../assets/Images/mainImage.png"
import "./style.css"
import { useUserInfo } from "../../context/user";

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const agency = new URLSearchParams(search).get("state");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");
  const saveActiveLocation = useUserInfo()[5];

  const associate = async ({ location }, creds) => {
    var payload = {
      _id: agency,
      ghl: {
        location_id: creds.locationId,
        company_id: location.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
      ghl_data: location
    };

    const { response, error } = await AppServices.accounts.update({ payload, toaster: true, });

    if (error) return setError(error.message);
    if (!response) return setError("Something went wrong while integration, please try latter");
    // update(payload);
    saveActiveLocation(response.data)
    return setError("Location Connect Successfully");
  };

  const getLocation = async (creds) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.location(creds.locationId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");

    return response && associate(response.data, creds) && setError("Location SuccessFully connected");
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.CLIENT_ID,
        client_secret: env.GHL.CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    const { response, error } = await AppServices.services.ghl.call_service({ payload });


    if (!response) return setError("Something went wrong while integration, please try latter");
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
    return response && getLocation(response.data);
  };

  const onLoad = () => {
    getCreds();
  };


  useEffect(onLoad, []);

  return (
    <div className="container">
      <img
        src={img}
        alt="bilal"
        className="image"
      />

      {!Error &&
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      }

      {Error && (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <p>
            {Error}
          </p>

          <div style={{ marginTop: "20px" }} className="">
            <button className="button" onClick={() => window.close()} >
              Go Back
            </button>
          </div>

        </div>
      )}
    </div>
  );
}

export default GHL;
